import { useWidthCheck } from '../../../../hooks';
import { MOBILE_WIDTH } from '../../../../settings';
import classNames from 'classnames';

type Props = {
  section: {
    images?: {
      desktop: string;
      mobile: string;
      alt: string;
    };
    image?: {
      desktop: string;
      mobile: string;
      alt: string;
    };
    description: string;
  };
  isActive: boolean;
};

const SizeAndCapacitySection = ({ section, isActive }: Props) => {
  const images = section.images ?? section.image;
  const { description } = section;
  const isMobView = useWidthCheck(MOBILE_WIDTH);

  return (
    <div className={classNames('tw-mb-10 tw-animate-[fadeIn_0.5s] last:tw-mb-0', { 'tw-hidden': !isActive })}>
      <div
        className={classNames(
          'tw-mx-auto tw-mb-10 tw-flex tw-h-[440px] tw-max-w-[880px] tw-items-center tw-justify-center md:tw-h-[380px]'
        )}>
        <img
          src={isMobView && images.mobile ? images.mobile : images.desktop}
          alt={images.alt}
          className='tw-max-h-[440px] tw-max-w-full md:tw-max-h-[380px]'
        />
      </div>
      {description && <div className='tw-text-center tw-font-normal tw-text-[#303030]'>{description}</div>}
    </div>
  );
};

export default SizeAndCapacitySection;
